module.exports = __webpack_public_path__ + "static/media/26UNRWA2.e8abda6b.jpg";